import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M4 22h16a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v16a2 2 0 0 1-2 2Zm0 0a2 2 0 0 1-2-2v-9c0-1.1.9-2 2-2h2",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(Path, { d: "M18 14h-8", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M15 18h-5", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M10 6h8v4h-8V6Z", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Newspaper";
const Newspaper = memo(themed(Icon));
export {
  Newspaper
};
//# sourceMappingURL=newspaper.js.map
